<template>
    <div>
        <div class="flex flex-col justify-center md:flex-row">
            <div class="text-3xl lg:text-6xl mr-2">
                Describo
            </div>
            <div class="text-lg lg:text-3xl md:mt-4 lg:mt-12">
                The tool to describe and package data.
            </div>
        </div>
        <div class="my-8 text-base lg:text-2xl text-center">
            Describo is a tool to create and update
            <a
                href="https://researchobject.github.io/ro-crate/"
                class="text-orange-600"
                >Research Object Crates (RO-Crate)</a
            >
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
